import { createClient } from "@supabase/supabase-js";
import { hybridSupabaseStorage } from "./supabaseStorage";

// Cle publique (anon/publishable) — la securite est assuree par les Row Level
// Security policies cote Supabase.
const supabaseUrl = "https://ztakvswkcqcgzmbphwsv.supabase.co";
const supabaseAnonKey = "sb_publishable_QpdlLMitkcap3pEN46qRYQ_AoNj-Ys_";

// Storage hybride localStorage + IndexedDB (via localforage) pour resister a
// Safari iPad ITP qui purge localStorage apres 7 jours d'inactivite.
// Voir client/src/lib/supabaseStorage.ts pour les details.
//
// `persistSession` + `autoRefreshToken` + `detectSessionInUrl` sont les
// defauts Supabase mais on les explicite pour eviter qu'un upgrade
// silencieux de la lib ne change le comportement.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: hybridSupabaseStorage,
    storageKey: "sb-ztakvswkcqcgzmbphwsv-auth-token",
  },
});
